<template>
	<div>
		<div class="fs5 lh125 fw7 c1 mb2">{{ $t("cancellation_reason") }}</div>
		<j-card class="flex-wrap xs-12 xs-right mb6 bg5 p2 c1 fs3">
			{{ cancellationReason }}
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"

export default {
	props: {
		cancellationReason: String
	},
	components: {
		JCard
	}
}
</script>

